import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, SortDescriptor } from '@progress/kendo-data-query';
import { NotifyType } from '../../../core/enums/NotifyType';
import {
  CartItem, DiscItem, IBaseResponse, ICartItem, ICountry, ICustomer,
  IDiscItem, IGetAllSupportDataForCheckOutOrderDetail, IMasterData,
  IOrderDetail, IOrderDetailsFormValidate, IState, OrderDetail, OrderDetailsFormValidate,
  AddressType,
  Customer
} from '../../../core/models';
import { AppNotifyService } from '../../../core/services/app-notify.service';
import { CheckoutService } from '../../../core/services/checkout.service';
import { HelperService } from '../../../core/services/helper.service';
import { JobService } from '../../../core/services/job.service';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { MasterDataService } from '../../../core/services/master-data.service';
import { UserService } from '../../../core/services/user.service';
import { tap, map, retry } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { load } from '@progress/kendo-angular-intl';
import { head } from 'lodash';
import { DiscountStoreService } from '../../../core/services/discount-store.service';
import { environment } from '../../../../environments/environment';
import { CustomerService } from '../../../core/services/customer.service';
import { error } from 'console';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public itemListGridData: GridDataResult;
  public skip = 0;
  public pageSize = 10;
  public itemGridLoading: boolean = true;
  imageURL: string;

  public gridState: State = {
    sort: [
      {
        field: 'itemNumber',
        dir: 'asc',
      },
    ],
    skip: 0,
    take: 10,
    group: [],
    // filter: {},
  };
    toastMessage: string;
    toastType: string;
    itemDocExistsList: string[];

  constructor(private appNotifyService: AppNotifyService,
    private masterDataService: MasterDataService,
    private checkoutService: CheckoutService,
    private jobService: JobService,
    private userService: UserService,
    private discountStoreService: DiscountStoreService,
    private languageTranslationService: LanguageTranslationService,
    private customerService: CustomerService,
    private helperService: HelperService) { }

  isDealOn: boolean = false;
  async ngOnInit() {
    this.imageURL = environment.imageBaseUrl + environment.imageFolder;
    this.isDealOn = await this.discountStoreService.getDealFlag().toPromise();
    console.log(this.isDealOn);
    if (!this.isDealOn) {
      //return
      console.log("return to home page");
    }
    this.minimumRequestDate();
    this.maximumRequestDate();
    //else proceed to the store
    this.currentBillToAddress = new Customer();
    this.currentBillToAddress.customerNumber = 82512;
    this.loadItems();
    this.initMasterDataForOrderDetails();
    await this.loadAddress();
    this.orderdetail = new OrderDetail();
    this.getItemDocExistsList();
  }



  gridSortChange(event): void {
    //// this.g
    //this.gridState.sort = event;
    //// console.log(this.gridState.sort);
    //this.loadItems();
  }

  public pageChange({ skip, take }: PageChangeEvent): void {
    //this.skip = skip;
    //this.pageSize = take;
    //this.filterItemRequestPayload.skip = skip;
    //this.filterItemRequestPayload.take = take;
    //this.loadItems();
  }
  applyFilter(event, field) {

  }
  onFilter(event, field) {
  }

  public labelList = {
    defaultViewLbl: 'Default',
    tileViewLbl: 'Tile',
    listViewLbl: 'List',
    finishLowercaseLbl: 'Finish',
    imageLbl: 'Image',
    paintLbl: 'Paint',
    sizeLbl: 'Size',
    quantityLbl: 'Quantity',//'Qty',
    itemDescriptionLbl: 'Description',
    itemNumberLbl: 'Item #',
    avlLocationLbl: "Available Location",
    avlQtyLbl: "Available Qty",
    priceLbl: "Price",
    listPriceLbl: 'List price',
    selectionLbl: 'Action',
    addToCartLbl: 'Add To Order',
    addToQuoteLbl: 'Add To Quote',
    buildLbl: 'Build',
    categoryLbl: 'CATEGORY',
    finishUppercaseLbl: 'FINISH',
    selectAllLbl: 'Select All',
    tileNoRecordLbl: 'No records available.',
    tileItemPerPageLbl: 'Items per Page',
    ofLbl: 'of',
    itemsLbl: 'items',
    clearSearchLbl: "Clear Search"
  }


  itemsListForOrder: DiscItem[] = [];



  /*
   1. filter sort section
   2. order section
   3. confirmation section
   4. admin grid
   5. add/edit admin
  */

  changeShippingAddress() {

  }

  //orderdetail: IOrderDetail = new OrderDetail();

  //public get orderdetail(): IOrderDetail {
  //  if (!this.checkOutProcessModel) { this.initExpressCheckoutModel(); }
  //  return this.checkOutProcessModel.orderDetail;
  //}




  //#region Order Details Master Data
  //public set getjobState(value: IState[]) {
  //  this.masterDataService.allStatesOfUsAndCanada = value;
  //}
  public marketSegments: { name: string, marketSegment: string, value: string }[] = [];
  public stateList: IState[];
  async initMasterDataForOrderDetails() {
    await this.masterDataService.getMarketSegments().then(r => {
      r.forEach((m: any) => {
        this.marketSegments.push({ name: m.name, marketSegment: m.name, value: m.value });
      });
    });

    await this.masterDataService.GetAllSupportDataForCheckOutOrderDetail().pipe(
      tap((response: IGetAllSupportDataForCheckOutOrderDetail) => {
        //this.masterDataService.countries = response.countries as ICountry[];
        //this.masterDataService.allStatesOfUsAndCanada = [...response.countries[0].states, ...response.countries[1].states];
        this.masterDataService.freightTerms = response.freightTerms as IMasterData[];
      })
    ).subscribe((response: IGetAllSupportDataForCheckOutOrderDetail) => {
      /*this.stateList = this.masterDataService.allStatesOfUsAndCanada;*/
    });
  }

  //public get getMarketSegment$(): Observable<IMasterData[]> {
  //  return this.masterDataService.GetMarketSegment();
  //}

  public get getFreightTerms$(): Observable<IMasterData[]> {
    return this.masterDataService.getFreightTerms$;
  }
  //#endregion


  //#region Navigation between Panels
  @ViewChild('panelbar', { static: false }) panel;
  continueToOrderDetailsPanel(index: number) {
    //1. Validate if move is allowed. that is user has selected item for order
    //2. close all current open panels and then open the order details panel
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    this.panel.childrenItems[index].expanded = true;
    this.panel.childrenItems[index].selected = true;

  }
  //#endregion

  //#region Item Selection Panel

  async loadItems() {
    this.itemGridLoading = true;
    try {
      let resp = await this.discountStoreService.getItemsForOrder().toPromise();
      this.itemsListForOrder = resp;
      this.itemsListForOrder.forEach((item, index) => {
        item.orderQty = 1;
        item.salePrice = parseFloat(item.salePrice.toFixed(2));
      })
      //console.log(this.itemsListForOrder);
      this.bindItemSelectionGrid();
    }
    catch (err) { }
    this.itemGridLoading = false;
  }


  handleItemQtyChanged(event, dataItem: IDiscItem) {
    //1. Check if order QTY is greater than available
    //2. Set the order QTY
    dataItem.orderQty = event;
  }

  checkoutOrderDetails: any;
  addItemToCart(item: IDiscItem) {
    if (!this.itemReviewGridData) {
      this.itemReviewGridData = []
    }
    if (item.orderQty < 1) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please add at least 1 item.');
      return;
    }
    if (item.orderQty > item.currentInventory) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Item quantity exceeds available quantity.');
      return;
    }
    const existingItemInCart = this.itemReviewGridData.find(x => x.itemId == item.itemId);
    if (existingItemInCart) {
      if ((existingItemInCart.orderQty + item.orderQty) > item.currentInventory) {
        this.appNotifyService.notify(NotifyType.ERROR, 'Total item quantity in order exceeds available quantity.');
        return;
      }
      existingItemInCart.orderQty = existingItemInCart.orderQty + item.orderQty;
    }
    else {
      this.itemReviewGridData.push(Object.assign({}, item));
    }
    //const temp = this.itemReviewGridData.filter(x => x.itemId != item.itemId);
    //this.itemReviewGridData = temp;
    //this.itemReviewGridData.push(Object.assign({}, item));//copy and store the item in cart
    this.bindReviewGridData();
    this.appNotifyService.notify(NotifyType.SUCCESS, 'Item selected.');
  }

  bindItemSelectionGrid() {
    this.displayHiddenImages();
    this.itemListGridData = process(this.itemsListForOrder, this.gridState);
  }
  public itemSelectionGridSortChange(sort: SortDescriptor[]): void {
    this.gridState.sort = sort;
    this.bindItemSelectionGrid();
  }
  public itemSelectionGridPageChange({ skip, take }: PageChangeEvent): void {
    this.gridState.skip = skip;
    this.gridState.take = take;
    this.bindItemSelectionGrid();
  }

  public itemSelectionDataStateChange(state: DataStateChangeEvent): void {
    this.gridState = state;
    this.bindItemSelectionGrid();
  }

  //#endregion

  //#region Item Review Panel

  public itemReviewGridResult: GridDataResult;
  public itemReviewGridData: IDiscItem[] = [];

  public itemReviewGridState: State = {
    sort: [
      {
        field: 'lineNumber',
        dir: 'asc',
      },
    ],
    skip: 0,
    take: 10,
    group: [],
  };

  public bindReviewGridData() {
    this.itemReviewGridResult = process(this.itemReviewGridData, this.itemReviewGridState);
  }
  public itemReviewGridPageChange({ skip, take }: PageChangeEvent) {
    this.itemReviewGridState.skip = skip;
    this.itemReviewGridState.take = take;
    this.bindReviewGridData();
  }

  public itemReviewGridSortChange(sort): void {
    this.itemReviewGridState.sort = sort;
    this.bindReviewGridData();
  }

  public cartReview = {
    gridTextLbl1: '* Applicable States Sales Tax will be added after the order is processed.',
    gridTextLbl2: '* Shipping Charge will be calculated at the time of order  processing.',
    gridTextLbl3: '* All painted orders will be invoiced at a minimum of $500.00  net per color.',
    finishLbl: 'Finish',
    paintLbl: 'Paint',
    sizeLbl: 'Size',
    quantityLbl: 'Quantity',
    uomLbl: 'UoM',
    lineLbl: 'Line #',
    unitLbl: 'Unit',
    itemLbl: 'Item #',
    extrusionLbl: 'Extrusion',
    descriptionLbl: 'Description',
    listPriceLbl: 'Price',
    multiplierLbl: 'Multiplier',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    totalPriceLbl: 'Total Price',

  }

  public get calculateOrderTotal(): number {
    if (this.itemReviewGridResult) {
      if (this.itemReviewGridData) {
        return (this.itemReviewGridData as DiscItem[]).map(
          item => parseFloat(item.salePrice.toFixed(2)) * item.orderQty
        ).reduce((a, b) => +(a + b).toFixed(2), 0);
      }
    }
    return 0;
  }

  //#region Set min date and Max Date
  public minRequestDate = new Date();
  public maxRequestDate = new Date();
  public minimumRequestDate = (): Date => {
    var todaysDate = new Date();
    this.minRequestDate.setDate(todaysDate.getDate() + 1);
    return new Date(this.minRequestDate.getFullYear(), this.minRequestDate.getMonth() + 1, this.minRequestDate.getDate());
  }
  public maximumRequestDate = (): Date => {
    var todaysDate = new Date();
    this.maxRequestDate.setDate(todaysDate.getDate() + 15);
    return new Date(this.maxRequestDate.getFullYear(), this.maxRequestDate.getMonth() + 1, this.maxRequestDate.getDate());
  }
  //#endregion



  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();
  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to remove the item ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }

  showCofirmationDialogToRemoveItemFromReviewGrid(dataItem: IDiscItem): Subject<boolean> {
    this.gridItemToRemove = dataItem;
    return this.removeConfirmationSubject;
  }
  public removeConfirmation(dataItem): Subject<boolean> {//not needed
    this.gridItemToRemove = dataItem;
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.removeHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  public async removeHandler() {
    const itemId = this.gridItemToRemove.itemId;
    try {
      let d = this.itemReviewGridData.filter(x => x.itemId != itemId);
      this.itemReviewGridData = d;
      this.gridItemToRemove = null;
      this.bindReviewGridData();
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected Item has been removed.");
    }
    catch (err) { }

    await this.loadItems();
  }

  //#endregion

  //#endregion

  //#region Order Details Panel
  orderInProcess: boolean = false;
  hasPlaceOrderAccess: boolean = true;
  orderdetail: IOrderDetail;
  orderConfirmationNo: string = "";
  orderDetailsForm: IOrderDetailsFormValidate = new OrderDetailsFormValidate();
  isOrderValid() {
    this.orderDetailsForm.isInvalidJobName = !this.orderdetail.jobName;
    //this.orderDetailsForm.isInvalidJobCity = !this.orderdetail.jobCity;
    this.orderDetailsForm.isInvalidMarketSegment = !this.orderdetail.marketSegment;
    /*this.orderDetailsForm.isInvalidJobState = !this.orderdetail.jobState;*/
    this.orderDetailsForm.isInvalidPO = !this.orderdetail.po;
    this.orderDetailsForm.isInvalidFreightTerms = !this.orderdetail.freightTerms;

    let isItemsInValid: boolean = false;
    if (!this.itemReviewGridData) { isItemsInValid = true; }
    if (this.itemReviewGridData.length == 0) { isItemsInValid = true; }

    if (this.orderDetailsForm.isInvalidJobName //|| this.orderDetailsForm.isInvalidJobCity
      || this.orderDetailsForm.isInvalidMarketSegment //|| this.orderDetailsForm.isInvalidJobState
      || this.orderDetailsForm.isInvalidPO || this.orderDetailsForm.isInvalidFreightTerms || isItemsInValid) {
      return false;
    }
    else { return true; }
  }
  placeOrder() {
    //1. Init Order
    //2. Validate Order
    //3. Place order
    console.log(this.orderdetail);
    //map the order details and prepare the final object
    if (this.orderInProcess) return;


    this.orderDetailsForm = new OrderDetailsFormValidate();
    this.orderDetailsForm.isSubmitted = true;
    if (!this.isOrderValid()) return;
    this.orderInProcess = true;
    this.orderConfirmationNo = "";
    let data = {};
    let header = {}
    let detail = [];
    header["JobName"] = this.orderdetail.jobName;
    //header["JobCity"] = this.orderdetail.jobCity;
    header["comments"] = this.orderdetail.comments;
    header["MarketSegmentName"] = this.orderdetail.marketSegment.name;
    header["MarketSegmentValue"] = this.orderdetail.marketSegment.value;
    //header["JobStateCode"] = this.orderdetail.jobState.stateCode;
    //header["JobStateDescription"] = this.orderdetail.jobState.stateDescription;
    header["PO"] = this.orderdetail.po;
    header["requestDate"] = this.orderdetail.requestDate;
    header["FreightTermsName"] = this.orderdetail.freightTerms.name;
    header["FreightTermsValue"] = this.orderdetail.freightTerms.value;
    const u = this.userService.readUserObject;
    header["ShipToCustomerNumber"] = this.currentShipToAddr.customerNumber;
    header["BillToCustomerNumber"] = Number(u.customerNumber);
    header["UserId"] = u.userId;
    header["ShipToCustomerName"] = this.currentShipToAddr.customerName;
    header["ShipToAddressLine1"] = this.currentShipToAddr.addressLine1;
    header["ShipToCity"] = this.currentShipToAddr.city;
    header["ShipToState"] = this.currentShipToAddr.state;
    header["ShipToZipCode"] = this.currentShipToAddr.zipCode;
    header["UserEmailId"] = u.userEmail;

    this.itemReviewGridData.forEach((item, index) => {
      const i = {};
      i["ItemId"] = item.itemId;
      i["Quantity"] = item.orderQty;
      detail.push(i);
    });
    data["header"] = header;
    data["detail"] = detail;

    /*try {*/
    this.discountStoreService.placeOrder(data).subscribe((resp: IBaseResponse) => {
      console.log(resp);
      if (resp.isError) {
        //show error to user
        this.orderAcknowledgementDialog.isError = true;
      }
      else {
        this.orderAcknowledgementDialog.isError = false;
        this.orderConfirmationNo = resp.data["confirmationNo"].toString();
      }
      console.log(this.orderConfirmationNo);
      this.orderInProcess = false;
      this.orderAcknowledgementDialog.opened = true;
      this.continueToOrderDetailsPanel(0);
    })

  }

  public orderAcknowledgementDialog = {
    opened: false,
    acknowledgeNumber: "",
    isError: false
  }

  continueShopping() {
    this.resetForm();
    this.orderAcknowledgementDialog.opened = false;
  }
  closeOrderAckDialog() {
    this.resetForm();
    this.orderAcknowledgementDialog.opened = false;
  }
  //#endregion
  //#region Common functions
  resetForm() {
    this.orderdetail = new OrderDetail();
    this.orderDetailsForm = new OrderDetailsFormValidate();
    this.itemReviewGridData = [];
    this.bindReviewGridData();
    this.loadItems();
  }
  //#endregion

  showSuggestionBox: any = true;

  //#region Shipping Address Section
  // Show shipping address popup, list all address in a grid, select one of them
  currentBillToAddress: ICustomer;
  currentShipToAddr: ICustomer;
  shippingAddressList: ICustomer[] = [];
  showShippingAddressModal: boolean = false;
  shipToGridLoading: boolean = false;
  launchAddressChangeModal() {
    this.showShippingAddressModal = true;
    this.bindAddressGrid();
  }
  closeAddressChangeModal() {
    this.showShippingAddressModal = false;
  }

  public addressGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: '',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public customarAddressGridView: GridDataResult
  public customerAddressGridSortChange(sort): void {
    this.addressGridstate.sort = sort;
    this.bindAddressGrid();
  }

  public customerAddressGridPageChange({ skip, take }: PageChangeEvent): void {
    this.addressGridstate.skip = skip;
    this.addressGridstate.take;
    this.bindAddressGrid();
  }

  public customerAddressDataStateChange(state: DataStateChangeEvent): void {
    this.addressGridstate = state;
    this.bindAddressGrid();
  }

  public async loadAddress() {
    this.shipToGridLoading = true;
    let c = await this.customerService.getAllAddressList().toPromise();
    this.shippingAddressList = c.filter((address: ICustomer) =>
      (address.billingType === AddressType.Shipping || address.billingType === AddressType.Both) && address.isActive);
    //find 1st default address and set it as ship to address
    const defAddr = this.shippingAddressList.find(x => x.isDefault);
    if (defAddr) {
      this.currentShipToAddr = defAddr;
    }
    else {
      this.currentShipToAddr = this.shippingAddressList[0];
    }
    this.shipToGridLoading = false;
  }

  public bindAddressGrid() {
    this.customarAddressGridView = process(this.shippingAddressList, this.addressGridstate);
  }

  public selectShippingAddress(dataItem: ICustomer): void {
    //unselect all existing ship tos
    const curSelectedAddrs = this.shippingAddressList.filter(x => x.isSelected);
    curSelectedAddrs.forEach((el, index) => {
      el.isSelected = false;
    });
    dataItem.isSelected = true;
    this.currentShipToAddr = dataItem;
  }

  public customarAddressLabelText = {
    addAddressLbl: 'Add New Shipping Address',
    manageAddressLbl: 'Manage Addresses',
    customerNumberLbl: 'Customer Number',
    nameLbl: 'Mailing Name',
    addressLine1Lbl: 'Address Line 1',
    addressLine2Lbl: 'Address Line 2',
    cityLbl: 'City',
    stateLbl: 'State',
    zipcodeLbl: 'Zip Code',
    countryLbl: 'Country',
    countyLbl: 'County',
    phoneNumberLbl: 'Phone Number',
    shippingAddressLbl: 'Shipping Address',
    selectAddressLbl: 'Select Address',
    duplicateAddressText1: 'We found similar addresses at the',
    duplicateAddressText2: 'you entered, you can either select address from the table below or click on',
    addNewAddressLbl: 'Add New Address',
    duplicateAddressText3: 'to create new address and customer',
    closeLbl: 'Close',
    selectLbl: 'Select',
    phoneValidationLbl: 'Phone number length should be minimum 10',
    changeAddressText: "Change Shipping Address",
    hideShippingAddressText: "Hide Shipping Addresses"
  };
  //#endregion

  public handleMissingImage(event: Event, dataItem) {
    dataItem.imageName = 'NA';
    (event.target as HTMLImageElement).style.display = 'none';
  }
  public displayHiddenImages() {
    try {
      for (var i = 0; i < document.getElementsByClassName('OverStockImage').length; i++) {
        (document.getElementsByClassName('OverStockImage')[i] as HTMLImageElement).style.display = '';
      }  
    } catch (e) {

    }
  }

  // #region overstock item PDF download
  public showToast(message: string, type: 'success' | 'error') {
    this.toastMessage = message;
    this.toastType = type;

    setTimeout(() => {
      this.toastMessage = '';
    }, 5000); 
  }
  public async getItemDocExistsList() {
    

    try {

        await this.discountStoreService.getItemDocExistsList().subscribe((response: any) => {

        this.itemDocExistsList = response.data;
        console.log("itemDocExistsList: ", this.itemDocExistsList);
        })

    } catch (ex) {
        console.log("Error occured: ", ex);
      }
  }

  public async onClickLongItemNumber(dataItem: any) {

    console.log("dataItem: ", dataItem);
    const itemId = dataItem.itemId;
    const itemNumber = dataItem.longItemNumber;

    try {

      var res = await this.discountStoreService.downloadFiles(itemId).subscribe((response) => {

        console.log("response: ", response);

        if (response.data) {
          const url = response.data.urlPath;
          const linkSource = 'data:application/pdf;base64,' + url;
          const downloadLink = document.createElement("a");
          const fileName = `${itemNumber}_merged.pdf`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();

          this.showToast("Downloaded PDFs successfully!", 'success'); 
  
        }
        else {
          this.showToast("No documents found for this item!", 'error');
        }
      });


    }
    catch (ex) {
      console.log("error", ex);

      this.showToast("Error occured during download!", 'error');
    }
  }


  // #endregion
}
